module.exports = __webpack_public_path__ + "static/media/spielwand-wichtel.16eb835f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/spielwand-wichtel.jpg
// module id = 108
// module chunks = 0